import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Text } from '@naf/text';
import { nafColor } from '@nafcore/theme';
import { spacing, borderRadius, breakpoints } from '@naf/theme';
import { Tag } from '@naf-simba/elements-tag';

export const BoxWrapper = styled.div<{ $hasBorder?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 635px;
  margin-bottom: ${spacing.space24};
  border-radius: ${borderRadius.M};

  ${({ $hasBorder }) =>
    $hasBorder &&
    css`
      border: 2px solid ${nafColor.neutral.neutral2};
    `}
`;

export const RadioContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: ${spacing.space24};
  cursor: pointer;
  gap: ${spacing.space16};
`;

export const RadioWrapper = styled.div<{ $leftPadding?: boolean }>`
  margin-top: ${spacing.space4};
  flex-shrink: 0;

  ${({ $leftPadding }) =>
    $leftPadding &&
    css`
      margin-left: ${spacing.space24};
    `}
`;

export const ContentWrapper = styled.div<{ $leftMargin?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${({ $leftMargin }) =>
    $leftMargin &&
    css`
      margin-left: ${spacing.space20};
    `}
`;

export const TitleText = styled(Text)`
  margin: 0;
`;

export const BottomSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 ${spacing.space24} ${spacing.space24} ${spacing.space64};

  @media (max-width: ${breakpoints.s}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${breakpoints.m}) {
    padding-left: 0;
  }
`;

export const Price = styled(Text)`
  margin: 0;
`;

export const ReadMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: ${nafColor.signature.black};
  cursor: pointer;
  padding: ${spacing.space8};
  min-width: 44px;
  min-height: 44px;
  flex-shrink: 0;
  margin-left: auto;
  margin-top: -${spacing.space12};
  margin-right: -${spacing.space12};

  @media (max-width: ${breakpoints.m}) {
    padding: ${spacing.space12};
  }
`;

export const ChevronIcon = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;

export const ExpandedContent = styled.div`
  padding: ${spacing.space8} ${spacing.space24} ${spacing.space24} ${spacing.space4};
  margin-top: -${spacing.space16};

  @media (max-width: ${breakpoints.s}) {
    padding: ${spacing.space8} 0 ${spacing.space24} ${spacing.space4};
  }
`;

export const StyledTag = styled(Tag)`
  position: absolute;
  top: -12px;
  left: ${spacing.space16};
`;

export const SimpleBoxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 635px;
  cursor: pointer;
`;
